__turbopack_context__.v({
  "panel": "Tabs-module__bxw1SW__panel",
  "root": "Tabs-module__bxw1SW__root",
  "tab": "Tabs-module__bxw1SW__tab",
  "tabList": "Tabs-module__bxw1SW__tabList",
});
